function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1286_3184)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1286_3184)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6406 1.88895L2.97396 1.89767C2.62034 1.89792 2.28129 2.03862 2.03142 2.28885C1.78154 2.53907 1.6413 2.8783 1.64154 3.23192L1.64292 5.23192C1.64304 5.40873 1.7134 5.57825 1.83851 5.70319C1.96362 5.82813 2.13323 5.89825 2.31004 5.89813L16.31 5.88849C16.4869 5.88837 16.6564 5.81802 16.7813 5.69291C16.9062 5.5678 16.9764 5.39818 16.9762 5.22137L16.9749 3.22137C16.9746 2.86775 16.8339 2.5287 16.5837 2.27883C16.3335 2.02895 15.9942 1.88871 15.6406 1.88895Z",
  fill: "#222222"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6441 6.88895L2.97746 6.89767C2.80065 6.8978 2.63113 6.96815 2.50619 7.09326C2.38125 7.21837 2.31113 7.38799 2.31125 7.5648L2.31515 13.2315C2.31539 13.5851 2.4561 13.9241 2.70632 14.174C2.95654 14.4239 3.29578 14.5641 3.6494 14.5639L14.9827 14.5561C15.3364 14.5558 15.6754 14.4151 15.9253 14.1649C16.1751 13.9147 16.3154 13.5754 16.3151 13.2218L16.3112 7.55516C16.3111 7.37835 16.2408 7.20883 16.1157 7.08389C15.9906 6.95895 15.8209 6.88883 15.6441 6.88895ZM11.4791 9.22515C11.4789 9.44606 11.3911 9.65788 11.235 9.81419C11.0789 9.9705 10.8672 10.0586 10.6463 10.0591L7.97964 10.0609C7.75862 10.061 7.5466 9.9734 7.39021 9.81723C7.23382 9.66105 7.14588 9.44915 7.14573 9.22814C7.14558 9.00712 7.23323 8.7951 7.3894 8.63871C7.54557 8.48233 7.75748 8.39438 7.97849 8.39423L10.6452 8.3924C10.8661 8.3926 11.0779 8.48036 11.2342 8.63646C11.3905 8.79255 11.4786 9.00425 11.4791 9.22515Z",
  fill: "#222222"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1286_3184"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.973145 0.565704) rotate(-0.0394413)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1286_3184"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.973145 0.565704) rotate(-0.0394413)"
})));

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.3d75f162.svg";
export { ForwardRef as ReactComponent };